import { EGameEvents } from '@Managers/Events/GameEvents';
import { IErrorState } from '@GameStore/GameStoreSchema';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EPopNotificationError } from '@Managers/PopClient/UsePopClient.types';

export const processErrorData = (error: string, code: string): IErrorState => {
    const errorList = ConfigLoader.getConfiguration(EConfigurationNames.CONNECTION).errorRangeList;

    const codeNumber = JSON.parse(code.split('_')[1]);
    let category;

    for (let key in errorList) {
        if (errorList[key].range[0] <= codeNumber && codeNumber <= errorList[key].range[1]) {
            category = errorList[key].popClientCategory;
        }
    }

    const errorState = {
        code: code,
        error: error,
        category: category || EPopNotificationError.GENERIC_ERROR
    };

    console.warn('processErrorResponse', errorState);

    EventsCenter.emit(EGameEvents.ERROR, errorState);
    return errorState;
};
